module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/LeCreuset-72f88e3ebdf21cf07e3ca44cdada9912.png";